var CALCULATOR_FORM = {
	"Chain Link":{
	   
	   "Residential Galvanized Chain Link":{
		  "36\" Chain Link":{
			 "Galvanized":"36-residential-galvanized-chain-link"
		  },
		  "42\" Chain Link":{
			 "Galvanized":"42-residential-galvanized-chain-link"
		  },
		  "48\" Chain Link":{
			 "Galvanized":"48-residential-galvanized-chain-link"
		  },
		  "60\" Chain Link":{
			 "Galvanized":"60-residential-galvanized-chain-link"
		  },
		  "72\" Chain Link":{
			 "Galvanized":"72-residential-galvanized-chain-link"
		  }
	   },
	   "Vinyl Coated Residential Chain Link":{
		  "42\" Vinyl Coated Chain link":{
			 "Black":"42-vinyl-coated-residential-chain-link"
		  },
		  "48\" Vinyl Coated Chain link":{
			 "Black":"48-vinyl-coated-residential-chain-link"
		  },
		  "60\" Vinyl Coated Chain link":{
			 "Black":"60-vinyl-coated-residential-chain-link"
		  },
		  "72\" Vinyl Coated Chain link":{
			 "Black":"72-vinyl-coated-residential-chain-link"
		  }
	   }
	},
	"Ornamental":{
	   "Flat Top":{
		"4' Steel Flat Top":{
            "Black":"4-flat-top-ornamental-iron"
         },
         "5' Steel Flat Top":{
            "Black":"5-flat-top-ornamental-iron"
         },
         "6' Steel Flat Top":{
            "Black":"6-flat-top-ornamental-iron"
         }
		  // "6' Aluminum Flat Top":{
		  //    "":"6-aluminum-flat-top-ornamental"
		  // },
		  // "5' Aluminum Flat Top":{
		  //    "":"5-aluminum-flat-top-ornamental"
		  // },
		  // "4' Aluminum Flat Top":{
		  //    "":"4-aluminum-flat-top-ornamental"
		  // }
	   },
	   "Spear Top":{
        "5' Steel Spear Top":{
            "Black":"5-spear-top-ornamental-iron"
         },
         "6' Steel Spear Top":{
            "Black":"6-spear-top-ornamental-iron"
         }
		  // "6' Aluminum Spear Top":{
		  //    "":"6-aluminum-spear-top-ornamental"
		  // },
		  // "5' Aluminum Spear Top":{
		  //    "":"5-aluminum-spear-top-ornamental"
		  // },
		  // "4' Aluminum Spear Top":{
		  //    "":"4-aluminum-spear-top-ornamental"
		  // }
	   }
	},
	"Vinyl":{
	   "Privacy":{
		  "6' Privacy with Accent":{
			 "White":"6-privacy-picket-lattice-white-k-31"
		  },
		  "6' Privacy":{
			 "White":"6-privacy-white-k-373",
			 "Khaki":"6-privacy-khaki-k-373",
			 "Sandstone":"6-privacy-sandstone-k-373"
		  },
		  "6' Woodland Series":{
			 "Chestnut Brown":"6-woodland-series-chestnut-brown-afc-025si",
			 "Weathered Cedar":"6-woodland-series-weathered-cedar-afc-025si"
		  },
		  "5' Privacy":{
			 "White":"5-privacy-white-afc-005",
			 "Khaki":"5-privacy-khaki-afc-005"
		  },
		  "4' Privacy":{
			 "White":"4-privacy-white-afc-001",
			 "Khaki":"4-privacy-khaki-afc-001",
			 "Sandstone":"4-privacy-sandstone-afc-001"
		  }
	   },
	   "Semi-Privacy":{
		  "6' Semi-Privacy (3 Rail)":{
			 "White":"6-semi-privacy-white-afc-034",
			 "Sandstone":"6-semi-privacy-sandstone-afc-034"
		  },
		  "6' Semi-Privacy (2 Rail)":{
			 "White":"6-semi-privacy-white-afc-030",
			 "Sandstone":"6-semi-privacy-sandstone-afc-030"
		  },
		  "5' Semi-Privacy":{
			 "White":"5-semi-privacy-white-afc-c-32"
		  },
		  "4' Semi Privacy":{
			 "White":"4-semi-privacy-white-afc-0304",
			 "Sandstone":"4-semi-privacy-sandstone-afc-0304"
		  }
	   },
	   "Picket":{
		  "6' Picket":{
			 "White":"6-picket-white-afc-c61",
			 "Khaki":"6-picket-khaki-afc-c61",
			 "Sandstone":"6-picket-sandstone-afc-c61"
			
		  },
		  "5' Picket":{
			 "White":"5-picket-white-k-80",
			 "Sandstone":"5-picket-sandstone-k-80"
		  },
		  "4' Picket":{
			 "White":"4-picket-3-gap-white-k-15",
			 "Khaki":"4-picket-3-gap-khaki-k-15",
			 "Sandstone":"4-picket-3-gap-sandstone-k-15"
		  }
	   },
	   "Closed Picket":{
		  "5' Closed Picket":{
			 "White":"5-closed-picket-w-3-airspace-white-afc-014"
		  },
		  "4' Closed Picket":{
			 "White":"4-closed-picket-white-k-17",
			 "Khaki":"4-closed-picket-khaki-k-17",
			 "Sandstone":"4-closed-picket-sandstone-k-17"
		  }
	   },
	   "Overscallop Picket":{
		  "6' Overscallop":{
			 "White":"6-overscallop-white-afc-012",
			 "Sandstone":"6-overscallop-sandstone-afc-012"
		  },
		  "5' Overscallop":{
			 "White":"5-semi-privacy-overscallop-picket-white-afc-004"
		  },
		  "4' Overscallop":{
			 "White":"4-overscallop-white-afc-016",
			 "Khaki":"4-overscallop-khaki-afc-016",
			 "Sandstone":"4-overscallop-sandstone-afc-016"
		  }
	   },
	   "Underscallop Picket":{
		  "6' Underscallop":{
			 "White":"6-underscallop-white-afc-013"
		  },
		  "5' Underscallop":{
			 "White":"5-semi-privacy-underscallop-white-afc-003"
		  },
		  "4' Underscallop":{
			 "White":"4-underscallop-white-k-97",
			 "Khaki":"4-underscallop-khaki-k-97",
			 "Sandstone":"4-underscallop-sandstone-k-97"
		  }
	   },
	   "Ranch Rail":{
		  "5' (3 rail)":{
			 "White":"vinyl-3-rail-white-k-19a"
		  },
		  "3' (2 rail)":{
			 "White":"vinyl-2-rail-white-k-302"
		  }
	   }
	},
	"Wood":{
		"Solid / Privacy":{
		   "6' Solid Privacy with 5.5\" Pickets":{
			  "Cedar":"6-solid-wood" 
			  //"White Fir":"6-solid-wood",
			  //"Western Red Cedar":"6-solid-wood"
		   },
		   //"6' Solid with Custom 4\" Pickets":{
			  //"Cedar":"6-solid-wood-with-custom-4-pickets",
			  //"Western Red Cedar":"6-solid-wood-with-custom-4-pickets"
		   //},
		   "4' Solid Wood with 5.5\" Pickets":{
			  "Cedar":"4-solid-wood"
		   }
		},
		"Shadow Box":{
		   "6' Shadow Box with 5.5\" Pickets":{
			  "Cedar":"6-shadow-box-wood",
			  //"Western Red Cedar":"6-shadow-box-wood"
		   },
		   // "6' Shadow Box with Custom 4\" Pickets":{
		   //    "Cedar":"6-shadow-box-wood-with-custom-4-pickets",
		   //    //"Western Red Cedar":"6-shadow-box-wood-with-custom-4-pickets"
		   // },
		   // "4' Shadow Box with 4\" Pickets":{
		   //    "Cedar":"4-shadow-box-wood-with-4-pickets"
		   // },
		   "4' Shadow Box with 5.5\" Pickets":{
			  "Cedar":"4-shadow-box-wood-with-6-pickets"
		   }
		},
		"Picket":{
		   "6' Semi-Privacy - 5.5\" Pickets (1\" gap)":{
			  "Cedar":"6-picket-wood-w-1-gap",
			  //"Western Red Cedar":"6-picket-wood-w-1-gap"
		   },
		   // "6' French Gothic with 5.5\" Pickets (1\" gap)":{
		   //    "Cedar":"6-french-gothic-wood",
		   //    //"Western Red Cedar":"6-french-gothic-wood"
		   // },
		   // "6' Picket with 4\" pickets":{
		   //    "Cedar":"6-picket-wood-with-4-pickets",
		   //    //"Western Red Cedar":"6-picket-wood-with-4-pickets"
		   // },
		   "4' Picket Fence - 3.5\" Pickets (3\" gap)":{
			  "Cedar":"4-picket-wood-fence"
		   }  
		   // "4' French Gothic":{
		   //    "Cedar":"4-french-gothic-wood"
		   // }
		   
		   // "4' Picket w\/Capboard":{
		   //    "Cedar":"4-picket-wood-w-capboard"
		   // }
		},
		"Scalloped":{
			"6' Shadow Box - 5.5\" Pickets":{
				"Cedar":"6-shadow-box-scalloped-wood"
			 },
			 "6' Solid Privacy - 5.5\" Pickets":{
				"Cedar":"6-solid-scalloped-wood",
				//"Western Red Cedar":"6-solid-scalloped-wood"
			 },
			 "6' Picket - 5.5\" Pickets (1\" gap)":{
				"Cedar":"6-picket-scalloped-wood",
				//"Western Red Cedar":"6-picket-scalloped-wood"
			 },
			 "4' Shadow Box - 5.5\" Pickets":{
				"Cedar":"4-shadow-box-scalloped-wood"
			 },
			 "4' Solid Wood - 5.5\" Pickets":{
				"Cedar":"4-solid-scalloped-wood"
			 },
			 "4' Picket - 3.5\" Pickets (3\" gap) ":{
				"Cedar":"4-picket-scalloped-wood"
			 }
		}
	 }
 }
 
 var VINYL_OPENINGS = {
   
	 //******* generic gate references unless noted, need to update variants when new pictures are available ********
 
	 "6-privacy-picket-lattice-white-k-31" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
   
	 "6-privacy-white-k-373" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	 "6-privacy-khaki-k-373": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431285999
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551806703
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313642082543
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313759883503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764339951
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077634799
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766980335
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929313007
		 }
	 ],  
 
	 "6-privacy-sandstone-k-373": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571205359
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765322991
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077798639
		 },          
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767013103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929411311
		 }
	 ],  
 
	 "6-woodland-series-chestnut-brown-afc-025si": [
		 // *** updated these gate variant listings sku/ picture/ descriptions ***
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551741167
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313759555823
		 },
		 // *** end update ***
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177273071
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766914799
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929214703
		 }
	 ],
 
	 "6-woodland-series-weathered-cedar-afc-025si": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571303663
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765617903
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314078126319
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767078639
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929771759
		 }
	 ],  
 
	   "5-privacy-white-afc-005": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
 
	 "5-privacy-khaki-afc-005": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431122159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551184111
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641230575
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758605551
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764045039
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077143279
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766816495
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928952559
		 }
	 ],
 
	 "4-privacy-white-afc-001": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
 
	 "4-privacy-khaki-afc-001": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431056623
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313550299375
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641132271
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758474479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763619055
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076422383
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766652655
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928329967
		 }
	 ],
   
	 "4-privacy-sandstone-afc-001": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476243695
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313570353391
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313643950319
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763717359
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],
 
	 "6-semi-privacy-white-afc-034" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	 "6-semi-privacy-sandstone-afc-034": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571205359
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765322991
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077798639
		 },          
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767013103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929411311
		 }
	 ],  
 
	 "6-semi-privacy-white-afc-030" : [
		 // *** updated these gate variant listings sku/ picture/ descriptions ***
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 40193999274078
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 45743664496879
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 40194014052446
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 45743664660719
		 },
		 // *** end update ***              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	 "6-semi-privacy-sandstone-afc-030": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571205359
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765322991
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077798639
		 },          
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767013103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929411311
		 }
	 ],    
 
	 "5-semi-privacy-white-afc-c-32": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
 
	 "4-semi-privacy-white-afc-0304": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
   
	 "4-semi-privacy-sandstone-afc-0304": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476243695
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313570353391
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313643950319
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763717359
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],
 
	 "6-picket-white-afc-c61" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	 "6-picket-khaki-afc-c61": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431285999
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551806703
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313642082543
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313759883503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764339951
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077634799
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766980335
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929313007
		 }
	 ],  
 
	 "6-picket-sandstone-afc-c61": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571205359
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765322991
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077798639
		 },          
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767013103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929411311
		 }
	 ],  
 
	 "5-picket-white-k-80": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
   
	 "5-picket-sandstone-k-80": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 44020174487791
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 45743664759023
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177174767
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 45743664890095
		 },
	 ],          
 
	 "4-picket-3-gap-white-k-15": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
 
	 "4-picket-3-gap-khaki-k-15": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431056623
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313550299375
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641132271
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758474479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763619055
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076422383
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766652655
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928329967
		 }
	 ],
   
	 "4-picket-3-gap-sandstone-k-15": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476243695
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313570353391
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313643950319
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763717359
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],
 
	   "5-closed-picket-w-3-airspace-white-afc-014": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
 
	 "4-closed-picket-white-k-17": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
 
	 "4-closed-picket-khaki-k-17": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431056623
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313550299375
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641132271
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758474479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763619055
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076422383
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766652655
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928329967
		 }
	 ],
   
	 "4-closed-picket-sandstone-k-17": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 40208543940702
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 45743665119471
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 40208555966558
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 45743665250543
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],
 
	 "6-overscallop-white-afc-012" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	 "6-overscallop-sandstone-afc-012": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571205359
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765322991
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077798639
		 },          
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767013103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929411311
		 }
	 ], 
 
	   "5-semi-privacy-overscallop-picket-white-afc-004": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],  
 
	 "4-overscallop-white-afc-016": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
 
	 "4-overscallop-khaki-afc-016": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431056623
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313550299375
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641132271
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758474479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763619055
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076422383
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766652655
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928329967
		 }
	 ],
   
	 "4-overscallop-sandstone-afc-016": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476243695
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313570353391
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313643950319
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763717359
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],    
 
	 "6-underscallop-white-afc-013" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476538607
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571369199
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644966127
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765912815
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313765683439
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077438191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312767111407
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312930197743
		 }
	 ],
 
	   "5-semi-privacy-underscallop-white-afc-003": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476374767
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313571139823
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764208879
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 44020177240303
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766882031
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
 
	 "4-underscallop-white-k-97": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 31571964854366
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313551151343
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641165039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758540015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763979503
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314077012207
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766783727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928755951
		 }
	 ],  
 
	 "4-underscallop-khaki-k-97": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313431056623
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313550299375
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313641132271
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313758474479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763619055
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076422383
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766652655
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928329967
		 }
	 ],
   
	 "4-underscallop-sandstone-k-97": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313476243695
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313570353391
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313643950319
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763717359
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313763684591
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314076651759
		 },  
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312766718191
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312928362735
		 }
	 ],  
   
	 "vinyl-3-rail-white-k-19a": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 45743665348847
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313644114159
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 45743665447151
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313764176111
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 45743665676527
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 45743665578223
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312929181935
		 }
	 ],
 
	 "vinyl-2-rail-white-k-302": [
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 45743666200815
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 45743666135279
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 45743665873135
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 45743665774831
		 }
	 ]
 };
 
 
 var CHAIN_LINK_OPENINGS = {
	 "36-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314334044399
		 },
		  {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314334011631
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314334077167
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314334109935
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314332373231
		 },
	   {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314331848943
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314332405999
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314332438767
		 }
	 ],
	 "42-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314333323503
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314333389039
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314333454575
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314334142703
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314332471535
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314331881711
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314332012783
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314332045551
		 }
	 ],
	 "42-vinyl-coated-residential-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314329850095
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314329719023
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314329882863
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314329915631
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314327458031
		 },
		   {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314327359727
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314327490799
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314327523567
		 }
	 ],
	 "48-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314333520111
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314333651183
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314333683951
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314333716719
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314332504303
		 },
	   {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314331914479
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314332078319
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314332111087
		 }
	 ],
	 "48-vinyl-coated-residential-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314329948399
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314329751791
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314329981167
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314330013935
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314327556335
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314327294191
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314327589103
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314327621871
		 }
	 ],
	 "60-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314333749487
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314333815023
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314333847791
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314334175471
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314332537071
		 },
		{
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314331947247
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314332176623
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314332209391
		 }
	 ],
	 "60-vinyl-coated-residential-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314330079471
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314329784559
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314330112239
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314330046703
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314327720175
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314327392495
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314327752943
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314327785711
		 }
	 ],
	 "72-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314333880559
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314333946095
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314333978863
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314334208239
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314332569839
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314331980015
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314332274927
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314332307695
		 }
	 ],
	 "72-vinyl-coated-residential-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42314330145007
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42314329817327
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42314330177775
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314330210543
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42314327654639
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": 42314327425263
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42314327326959
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42314327687407
		 }
	 ]
 };
 var OI_OPENINGS = {
	 "3-aluminum-flat-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 16093452664926
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 16107833851998
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 16107974099038
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 16120105664606
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 16110745288798
		 }
	 ],
	 "3-flat-top-ornamental-iron": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": 42313462710511
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 42313566453999
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313761751279
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313953214703
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 28396868304990
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312924889327
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (12' opening)",
			 "Opening": 12,
			 "ID": 42312984428783
		 }
	 ],
	 "4-aluminum-flat-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 31289348423774
		 }
	 ],
	 "4-aluminum-spear-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 31289348423774
		 }
	 ],
	 "4-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": 42313567830255
		},          
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": 42313955115247
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": 42314113417455
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": 42312925282543
		}
	 ],
	 "4-spear-top-ornamental-iron": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 42313762013423
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313958064367
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": 42313956327663
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": 42312925675759
		 }
	 ],
	 "5-aluminum-flat-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 31289562431582
		 }
	 ],
	 "5-aluminum-spear-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": 31280793419870
		 }
	 ],
	 "5-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": 42313568452847
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": 42313959735535
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": 42314116595951
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": 42312926167279
		}
	 ],
	 "5-spear-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": 42313568944367
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": 42313962389743
		},
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": 42314116727023
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": 42312926560495
		}
	],
	 "6-aluminum-flat-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 31289598902366
		 }
	 ],
	 "6-aluminum-spear-top-ornamental": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": 31280798466142
		 }
	 ],
	 "6-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": 42313569730799
		},      
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": 42313963700463
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": 42314116989167
		},  
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": 42312926888175
		}
	 ],
	 "6-spear-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": 42313570124015
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": 42313966485743
		},
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": 42314117087471
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": 42312927314159
		}
	 ]
 };
 